// extracted by mini-css-extract-plugin
export default {"label":"DatosConnect_label__XSGcj","title":"DatosConnect_title__mnPou","info":"DatosConnect_info__CyCzp","code":"DatosConnect_code__DtQPp","button":"DatosConnect_button__FeC2w"};